module.exports = __webpack_public_path__ + "img/img_checknote.02ba5a23.svg";